import { useMutation } from '@tanstack/react-query';
import { postInstagramConnect } from '@/services/instagram.service';
import type { InstagramConnectResponse } from '@/types/instagram';

export const useInstagramConnect = () => {
    return useMutation<InstagramConnectResponse, unknown, void>({
        mutationFn: postInstagramConnect,
    });
};
